import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IReducer } from '../../redux/configureStore';
import authLogin from '../../redux/fetchActions/loginPage/loginPage';
import { PATHS } from '../../routes';
import Logo from '../../shared/components/Logo';
import Frame from './components/Frame';
import LoginButton from './components/LoginButton';
import LoginForm from './components/LoginForm';
import PasswordInput from './components/PasswordInput';
import PasswordLabel from './components/PasswordLabel';
import UserInput from './components/UserInput';
import UserLabel from './components/UserLabel';
import { setFormPassword, setFormUser } from './functions';
import { IFormData } from './interface';

function LoginPage() {
  const formData: IFormData = {
    email: '',
    password: '',
  };

  const loginContext = useSelector((reducer: IReducer) => reducer.loginAuth);
  const history = useHistory();
  const dispatch = useDispatch();
  const [form, setForm] = useState(formData);

  useEffect(() => {
    if (loginContext.isAuthenticated && loginContext.token !== null) {
      return history.push(PATHS.apis);
    }
    return history.push(PATHS.login);
  }, [loginContext]);

  return (
    <Frame.Base>
      <LoginForm
        onSubmit={(event) => {
          event.preventDefault();
          dispatch(authLogin(form));
        }}>
        <Logo width="224px" color="#125C5B" />
        <UserLabel>Usuário</UserLabel>
        <UserInput
          onChange={(event) => setFormUser(event, form, setForm)}
          name="email"
        />
        <PasswordLabel>Senha</PasswordLabel>
        <PasswordInput
          onChange={(event) => setFormPassword(event, form, setForm)}
          name="password"
        />
        <LoginButton type="submit">Login</LoginButton>
      </LoginForm>
    </Frame.Base>
  );
}

export default LoginPage;
